import { errorHandler } from "@/services/toastHandler";

const initState = () => ({
  loadingList: false,
  loadingUpset: false,
  loadingDelete: false,
});

export default {
  namespaced: true,
  state: initState(),
  mutations: {
    LOAD_UPSET_MULTI_BET_CONFIG: (s, data) => (s.loadingList = data),
    LOAD_UPSET_MULTI_BET_CONFIG: (s, data) => (s.loadingUpset = data),
    LOAD_DELETE_MULTI_BET_CONFIG: (s, data) => (s.loadingDelete = data),
  },

  actions: {
    async getConfigMultiBetList({ commit }, params) {
      commit("LOAD_LIST_MULTI_BET_CONFIG", true);
      try {
        const res = await this.$api.get(
          "/v1/portal/multi-bet-liability-band",
          {
            params,
          }
        );
        return res.data.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_LIST_MULTI_BET_CONFIG", false);
      }
    },
    async createConfigMultiBet({ commit }, data) {
      commit("LOAD_UPSET_MULTI_BET_CONFIG", true);
      try {
        const res = await this.$api.post(
          "/v1/portal/multi-bet-liability-band",
          data
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_UPSET_MULTI_BET_CONFIG", false);
      }
    },
    async deleteConfigMultiBet({ commit }, id) {
      commit("LOAD_DELETE_MULTI_BET_CONFIG", true);
      try {
        const res = await this.$api.delete(
          `/v1/portal/multi-bet-liability-band/${id}`
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_DELETE_MULTI_BET_CONFIG", false);
      }
    },
    async deleteAllConfigMultiBet({ commit }) {
      commit("LOAD_DELETE_MULTI_BET_CONFIG", true);
      try {
        const res = await this.$api.delete(
          '/v1/portal/multi-bet-liability-band'
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_DELETE_MULTI_BET_CONFIG", false);
      }
    },
    async updateConfigMultiBet({ commit }, data) {
      commit("LOAD_UPSET_MULTI_BET_CONFIG", true);
      try {
        const { id, ...rest } = data;
        const res = await this.$api.put(
          `/v1/portal/multi-bet-liability-band/${id}`,
          rest
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_UPSET_MULTI_BET_CONFIG", false);
      }
    },
  },
};
